var path = '/app/components/html-textarea.component.html';
var html = "<div class=\"editor\"></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;